import { mergeTemplate } from './base-template';

export const coachingTemplate = mergeTemplate({
  name: 'Coaching & Supervision',
  icon: '🧭',
  settings: {
    primaryColor: '#166534',
    accentColor: '#65a30d',
    fontStack: 'instrument',
    stylePreset: 'editorial',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Coaching-Angebote',
      heroSubtitle: 'Individuelle Begleitung für persönliches Wachstum',
      packages: [
        { name: 'Einzelcoaching', price: 'CHF 220/Session', description: 'Persönliches 1:1 Coaching', features: '90 Minuten, Zielklärung, Ressourcenarbeit, Transferübungen, Protokoll', highlighted: false },
        { name: 'Team-Coaching', price: "ab CHF 1'800/Tag", description: 'Teamentwicklung und Zusammenarbeit', features: 'Teamdiagnose, Moderation, Konfliktbearbeitung, Massnahmenplan', highlighted: true },
        { name: 'Workshop', price: "ab CHF 2'500/Tag", description: 'Themenspezifische Gruppenformate', features: 'Resilienz, Führung, Kommunikation, Selbstmanagement, Reflexion', highlighted: false },
      ],
      ctaTitle: 'Der erste Schritt zählt',
      ctaText: 'Vereinbaren Sie ein kostenloses Kennenlerngespräch — 30 Minuten, unverbindlich.',
      ctaButtonText: 'Kennenlerngespräch buchen',
    },
    pageMethoden: {
      heroTitle: 'Mein Coaching-Ansatz',
      heroSubtitle: 'Systemisch, lösungsorientiert, ressourcenbasiert',
      introText: 'Coaching ist kein Ratschlag, sondern ein Prozess. Ich begleite Sie dabei, Ihre eigenen Lösungen zu finden und umzusetzen.',
      steps: [
        { title: 'Erstgespräch', description: 'Kennenlernen, Anliegen klären, Erwartungen abstimmen' },
        { title: 'Zieldefinition', description: 'Konkrete, messbare Ziele für den Coaching-Prozess' },
        { title: 'Coaching-Prozess', description: 'Regelmässige Sessions mit Reflexion und Transferaufgaben' },
        { title: 'Integration', description: 'Verankerung der Erkenntnisse im Alltag und Abschluss' },
      ],
      tools: [
        { name: 'Systemisches Coaching', description: 'Ganzheitliche Perspektive auf Wechselwirkungen' },
        { name: 'Lösungsfokussierte Ansätze', description: 'Orientierung an Stärken statt an Defiziten' },
        { name: 'Achtsamkeitsbasierte Methoden', description: 'Präsenz und Selbstwahrnehmung stärken' },
      ],
      philosophyTitle: 'Coaching-Philosophie',
      philosophyText: 'Jeder Mensch trägt die Lösung in sich. Meine Aufgabe ist es, den Raum zu schaffen, in dem sie sichtbar wird.',
    },
    pageUeberMich: {
      heroTitle: 'Über mich',
      heroSubtitle: 'Coach, Supervisor, Sparringpartner',
      introText: 'Mit über 10 Jahren Erfahrung in Coaching und Supervision begleite ich Menschen und Teams durch Veränderungsprozesse.',
      imageUrl: '',
      timeline: [
        { year: '2012', text: 'Ausbildung zum Systemischen Coach' },
        { year: '2016', text: 'Supervisor BSO' },
        { year: '2020', text: 'Spezialisierung auf Führungskräfte-Coaching' },
      ],
      values: [
        { title: 'Vertraulichkeit', description: 'Was im Coaching-Raum passiert, bleibt dort' },
        { title: 'Wertschätzung', description: 'Begegnung auf Augenhöhe, ohne Bewertung' },
        { title: 'Wirksamkeit', description: 'Coaching muss im Alltag spürbar werden' },
      ],
      certifications: 'BSO-anerkannt, ICF ACC, MAS Coaching & Supervision ZHAW',
    },
  },
  components: {
    header: {
      companyName: 'Coaching Muster',
      logoText: 'CM',
      navItems: ['Angebote', 'Methoden', 'Team', 'Kontakt'],
      ctaText: 'Erstgespräch',
    },
    hero: {
      title: 'Klarheit finden. Wachsen.',
      subtitle: 'Coaching und Supervision für Menschen in Veränderung.',
      primaryBtn: 'Erstgespräch buchen',
      secondaryBtn: 'Angebot',
      imageUrl: '',
    },
    trust: {
      items: [
        { value: 'Vertraulich', label: 'Raum' },
        { value: 'Systemisch', label: 'Ansatz' },
        { value: 'Ressourcen', label: 'Fokus' },
        { value: 'Erfahren', label: 'Begleitung' },
      ],
    },
    services: {
      title: 'Angebot',
      subtitle: 'Für Einzelne und Teams.',
      items: [
        {
          icon: '🧭',
          title: 'Einzelcoaching',
          text: 'Berufliche Neuorientierung, Führung, Balance.',
        },
        {
          icon: '👥',
          title: 'Teamcoaching',
          text: 'Zusammenarbeit, Konflikte, Entwicklung.',
        },
        {
          icon: '🔍',
          title: 'Supervision',
          text: 'Reflexion für Fachpersonen und Teams.',
        },
      ],
    },
    benefits: {
      title: 'Was Sie gewinnen',
      subtitle: '',
      items: [
        {
          title: 'Klarheit',
          text: 'Komplexität reduzieren, Optionen erkennen.',
        },
        {
          title: 'Handlungsfähigkeit',
          text: 'Nächste Schritte definieren und umsetzen.',
        },
        {
          title: 'Entwicklung',
          text: 'Potenziale entfalten, Muster verändern.',
        },
      ],
    },
    team: {
      title: 'Über uns',
      subtitle: 'Erfahrene Coaches und Supervisoren.',
      members: [
        {
          name: 'Elisabeth Wenger',
          role: 'Coach & Supervisorin BSO',
          image: '',
          bio: 'Systemisches Coaching, Führungskräfteentwicklung, Teamsupervision. MAS Coaching ZHAW.',
        },
        {
          name: 'Andreas Blaser',
          role: 'Coach & Organisationsberater',
          image: '',
          bio: 'Lösungsfokussiertes Coaching, Change-Begleitung, Resilienztraining. ICF ACC.',
        },
      ],
    },
    testimonials: {
      title: 'Stimmen',
      items: [
        {
          quote: 'Die richtigen Fragen zur richtigen Zeit.',
          author: 'Markus Roth',
          role: 'Führungskraft, Industrieunternehmen',
        },
        {
          quote: 'Das Coaching hat mir geholfen, meine berufliche Neuorientierung klar und strukturiert anzugehen.',
          author: 'Sandra Vogt',
          role: 'Projektleiterin im Karrierewechsel',
        },
        {
          quote: 'Sehr wertschätzend und trotzdem herausfordernd. Genau die richtige Balance.',
          author: 'Thomas Eigenmann',
          role: 'Teamleiter, öffentliche Verwaltung',
        },
        {
          quote: 'Die Teamsupervision hat unsere Zusammenarbeit spürbar verbessert.',
          author: 'Claudia Brunner',
          role: 'Bereichsleiterin, Sozialwesen',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: '',
      items: [
        {
          question: 'Wie viele Sitzungen braucht es?',
          answer:
            'Das hängt vom Thema ab. Oft reichen 3 bis 6 Sitzungen für eine gute Wirkung. Im Erstgespräch klären wir gemeinsam den voraussichtlichen Umfang.',
        },
        {
          question: 'Was ist der Unterschied zwischen Coaching und Supervision?',
          answer:
            'Coaching fokussiert auf persönliche oder berufliche Ziele. Supervision ist Reflexion der eigenen Berufsrolle — oft für Fachpersonen in sozialen, pädagogischen oder therapeutischen Berufen.',
        },
        {
          question: 'Übernimmt der Arbeitgeber die Kosten?',
          answer:
            'Viele Unternehmen beteiligen sich an Coaching-Kosten oder beauftragen es direkt. Wir erstellen gerne eine Offerte für Ihren Arbeitgeber.',
        },
      ],
    },
    cta: {
      title: 'Erstgespräch buchen',
      subtitle:
        'Unverbindlich – wir klären, ob eine Zusammenarbeit passt.',
      phone: '+41 00 000 00 00',
      email: 'coaching@example.ch',
    },
    footer: {
      companyName: 'Coaching Muster',
      tagline: 'Coaching in Ihrer Region.',
      address: 'Musterstrasse 1, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'coaching@example.ch',
    },
  },
});
